import { useEffect, useState } from 'react';
import useAPI from '../../../../hooks/useAPI';

const TTL_MS = 5 * 60 * 1000;

let cache = null;
let cachedAt = 0;
let inflight = null;

export const invalidateApprovedTemplates = () => {
  cache = null;
  cachedAt = 0;
  inflight = null;
};

const isFresh = () => cache && Date.now() - cachedAt < TTL_MS;

const useApprovedTemplates = () => {
  const { urlAPI_2, fetchWithAuth } = useAPI();
  const [templates, setTemplates] = useState(() => (isFresh() ? cache : []));
  const [loading, setLoading] = useState(() => !isFresh());

  useEffect(() => {
    let active = true;

    if (isFresh()) {
      setTemplates(cache);
      setLoading(false);
      return () => {
        active = false;
      };
    }

    if (!inflight) {
      inflight = (async () => {
        const url = urlAPI_2 + 'templates';
        const options = { method: 'GET', mode: 'cors' };
        const response = await fetchWithAuth(url, options);
        const result = await response.json();

        if (result?.type !== 'success') return [];

        const list = Array.isArray(result?.data) ? result.data : [];
        return list
          .filter((tem) => tem?.status === 'APROBADA' && tem?.isActive === true)
          .map((tem) => ({
            label: `${tem.name} (#${tem.id})`,
            value: String(tem.id),
            template: tem,
          }));
      })()
        .then((list) => {
          cache = list;
          cachedAt = Date.now();
          inflight = null;
          return list;
        })
        .catch((error) => {
          console.error('error al consultar las plantillas', error);
          inflight = null;
          return [];
        });
    }

    setLoading(true);
    inflight.then((list) => {
      if (!active) return;
      setTemplates(list);
      setLoading(false);
    });

    return () => {
      active = false;
    };
  }, [urlAPI_2, fetchWithAuth]);

  return { templates, loading };
};

export default useApprovedTemplates;
